<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            d="M15.4141 4.53076C15.6728 4.20753 16.1454 4.15497 16.4688 4.41357C16.7921 4.67228 16.8445 5.14482 16.5859 5.46826L8.58594 15.4683C8.45268 15.6348 8.25399 15.7367 8.04102 15.7485C7.82817 15.7602 7.62046 15.6805 7.46973 15.5298L3.46973 11.5298C3.17695 11.2369 3.17687 10.7621 3.46973 10.4692C3.76259 10.1766 4.23743 10.1765 4.53027 10.4692L7.9375 13.8765L15.4141 4.53076Z"
            fill="currentColor"
        />
    </svg>
</template>
